export default __webpack_public_path__ + "static/media/logo_GMX_small.eb702c03.svg";